module.exports = __webpack_public_path__ + "static/img/product.0a4bc569.png";